import { DOCUMENT } from '@angular/common';
import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Inject,
	Input,
	Output,
	Renderer2,
	ViewChild,
} from '@angular/core';
import { enterAnimation } from 'app/utils/animations.util';
import * as dialogPolyfill from 'dialog-polyfill/dist/dialog-polyfill';

@Component({
	selector: 'office-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./dialog.scss', './modal.component.scss'],
	animations: [enterAnimation],
})
export class OfficeModalComponent {
	private _isOpen = false;

	constructor(
		private renderer: Renderer2,
		@Inject(DOCUMENT) private document: Document
	) {}

	@HostListener('document:keydown.escape', ['$event'])
	handleEscPress() {
		this.close();
	}

	@Input() set isOpen(open: boolean) {
		if (open) {
			this.renderer.addClass(this.document.body, 'modal--body-overflow-hidden');
		} else {
			this.renderer.removeClass(
				this.document.body,
				'modal--body-overflow-hidden'
			);
		}
		this._isOpen = open;
	}

	get isOpen() {
		return this._isOpen;
	}

	@Output() requestClose = new EventEmitter<void>();

	@ViewChild('dialogRef', { static: true })
	dialogRef: ElementRef<HTMLDialogElement>;

	close() {
		this.requestClose.emit();
	}

	ngAfterViewInit() {
		dialogPolyfill.registerDialog(this.dialogRef.nativeElement);
	}

	ngOnDestroy() {
		// We need to be sure to unlock the scroll also when the modal doesn't get closed via prop.
		this.renderer.removeClass(
			this.document.body,
			'modal--body-overflow-hidden'
		);
	}
}
